"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const Input = styled_1.default.input `
	all: initial;
	box-sizing: border-box;
	font-family: ${merlin_theme_1.default.typography.fonts.icons};
	background-color: unset;
	background-color: ${merlin_theme_1.default.colours.background.lighter};
	position: relative;
	border: 1px solid ${merlin_theme_1.default.colours.delimiter.dark};
	border-radius: ${merlin_theme_1.default.layout.radius.squared};
	width: 40px;
	height: 40px;
	display: block;
	cursor: pointer;
	transition: border 0.2s;
	flex: 0 0 auto;

	&:hover {
		border: 1px solid ${merlin_theme_1.default.colours.neutral.dark};
	}

	&:checked {
		display: inline-block;
	}

	&:focus:after {
		content: '';
		position: absolute;
		border-radius: calc(${merlin_theme_1.default.layout.radius.squared} + 2px);
		border: 1px solid ${merlin_theme_1.default.colours.highlight.default};
		width: 40px;
		height: 40px;
		padding: 21px;
		top: -3px;
		left: -3px;
	}
	&:checked:before {
		content: "\\e908";
		font-family: ${merlin_theme_1.default.typography.fonts.icons};
		font-weight: 800;
		color: ${merlin_theme_1.default.colours.neutral.darker};
		-webkit-font-smoothing: antialiased;
		font-size: 2rem;
		transform: translate(15%, 30%);
		display: inline-block;
		height: 16px;
		width: 16px;
	}
`;
const Checkbox = ({ name, checked, onChange, disabled }) => {
    return (React.createElement(Input, { "data-testid": `test-checkbox-${name}`, name: name, type: "checkbox", onChange: () => onChange(name, !checked), checked: checked, disabled: disabled !== undefined ? disabled : false }));
};
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map